
//Progress Circle
//<progress-circle id='progress' percent='' size='' thickness='' textSize=''></progress-circle>
// percent - The progress value that is passed to the element. Element updates automatically when this value is changed
// size - sets the total height and width of the element.
// thickness - sets the thickness of the progress bar
// textsize - sets the size of the progress text inside the circle
class progressCircle extends HTMLElement{
    static get observedAttributes(){
        return ['percent'];
    }
    constructor(){
        super();
        var size = this.getAttribute('size');
        var thickness = this.getAttribute('thickness') || 20;
        var percent = this.getAttribute('percent');
        var textSize = this.getAttribute('textSize') || size/4;
        const shadowDom = this.attachShadow({mode:'open'});
        const css = document.createElement('style');
        css.innerHTML = `
            #container{
                background-color: transparent;
                height: ${size}px;
                width: ${size}px;
                border-radius:100%;
                text-align: center;
            }
            #center{
                position: absolute;
                height:${size}px;
                width:${size}px;
                background-color:transparent;
            }
            .progress-ring{
                white-space:nowrap;
            }
            .progress-ring_circle {
                transition: 0.35s stroke-dashoffset;
                transform: rotate(-90deg);
                transform-origin: 50% 50%;
                z-index:10;
            }
    `   ;
        const container = document.createElement('div');
        container.id = 'container';

        shadowDom.appendChild(css);
        shadowDom.appendChild(container);
        container.innerHTML = `
          <svg
             class="progress-ring"
             width="${size}px"
             height="${size}px">
            <text
              font-size="${textSize}"
              x="50%"
              y="50%"
              text-anchor="middle"
              alignment-baseline="central">
            ${percent}%
            </text>
            <circle
              class="progress-ring_circle"
              stroke="#5C95FF"
              stroke-width="${thickness}"
              fill="transparent"
              r="${(size/2)-(thickness/2)}"
              cx="${size/2}"
              cy="${size/2}"/>
            
            <circle
              class="background-ring_circle"
              stroke="#5C95FF"
              stroke-width="${thickness}"
              stroke-opacity="25%"
              fill="transparent"
              r="${(size/2)-(thickness/2)}"
              cx="${size/2}"
              cy="${size/2}"/>
          </svg>
        `;
        this.setProgress = function(elem){
            var percent = this.getAttribute('percent');
            var cir = elem.shadowRoot.querySelector('circle');
            var text = elem.shadowRoot.querySelector('text');
            text.innerHTML = `${percent}%`;
            var radius = cir.r.baseVal.value;
            var circumference = radius * 2 * Math.PI;
            var offset = circumference - percent / 100 * circumference;
            cir.style.strokeDasharray = `${circumference} ${circumference}`;
            cir.style.strokeDashoffset = offset;
        };
    }

    connectedCallback(){
        this.setProgress(this);
    }

    attributeChangedCallback(attr, oldval, newval){
        this.setProgress(this);
    }

}
customElements.define('progress-circle', progressCircle);
'use strict';

(function() {
    /***
     * Without a trailing slash, the AngularJS / Angular hybrid routing will cause an endless loop.
     * This script addresses that by forcing a trailing slash.
     */
    const urlWithTrailingSlash = window.location.href.replace(/^(https?:\/\/[^/]+(?:\/[a-z0-9_]+)+)(\#.*)?$/, '$1/$2');
    const shouldRedirect = urlWithTrailingSlash !== window.location.href;
    if (shouldRedirect) {
        window.location.href = urlWithTrailingSlash;
    }
})();

if (!window.location.origin) { //polyfill for IE
    window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
}

